import React, { useCallback, useState } from "react";
import styles from "./styles.module.css";
import clsx from "clsx";
import GameStatusNotch from "../GameStatusNotch";
import mahaMegaBanner from "../../assets/maha-mega-banner.svg";
import ImageComponent from "../ImageComponent";
import ProgressBar from "../../components/ProgressBar";
import { useTranslation } from "react-i18next";
import { WidgetItem } from "../../interfaces/TournamentsConfig";
import { useNavigate } from "react-router-dom";
import { useTokenStore } from "../../storage/tokenState";
import _isEmpty from "lodash/isEmpty";
import { CLEVERTAP_EVENTS, NAVIGATION_ROUTES } from "../../constant";
import { nxTournamentText } from "../../utils/helpers/TournamentNXUtils";
import { SCREEN_NAMES } from "../../utils/helpers/constants";
import { pushClevertapEvent } from "../../utils/analytics/clevertap";
import { useTournamentNavigation } from "../../utils/helpers/tournamentNavigationHelper";
import { debounce } from "lodash";
import { handleClickCTEventRegisterTournamentNonLoggedInUser } from "../../utils/events/events";
import { getPartnerId } from "../../utils/helpers/common";
import { FbPixelEvent_Lead } from "../../utils/FbPixel/fbPixel";
import { FACEBOOK } from "../../utils/helpers/constants";

const LUDONX = "ludonx"

interface MahaMegaTournamentCardProps {
  loading?: boolean;
  items?: WidgetItem[];
  isCollapsable?: boolean;
  widgetIndex?: number;
  firstMahaMegaTournamentIndex?: number;
}

const MahaMegaTournamentCard: React.FC<MahaMegaTournamentCardProps> = (
  props
) => {
  const { t } = useTranslation();
  const { items = [], isCollapsable=false } = props;
  const tournament = items[0]
  const { numRegistrations = 0, maxParticipants = 0, displayImage='', ltid } = items[0];
  const navigate = useNavigate();
  const { token: userToken } = useTokenStore();
  const gameName = LUDONX
  const [isClicking, setIsClicking] = useState<boolean>(false);
  const { title="", containerStyle, textColor } = nxTournamentText(tournament, t)
  const {widgetIndex,firstMahaMegaTournamentIndex} = props;
  const {
    isBtnDisabled,
    registerLoading,
    isPolling,
    handleNavigation,
    LoaderOverlay
  } = useTournamentNavigation({ gameName, ltid });

  // Clevertap events
  const handleClickCTEventForNonLoggedInUser = useCallback(() => {
    pushClevertapEvent(CLEVERTAP_EVENTS.EVENT_PWA_PHONE_NUMBER_SCREEN, {
      "location": "lobby",
      "cardType": "mahaMega"
    });
  }, []);

  const handleClickCTEventForLoggedInUser = useCallback(() => {
    pushClevertapEvent(CLEVERTAP_EVENTS.EVENT_PWA_REGISTER_TOURNAMENT, {
      "location": "lobby",
      "cardType": "mahaMega"
    });
  }, []);

  const debouncedJoinTournament = useCallback(
    debounce((e?: React.MouseEvent<HTMLDivElement | HTMLButtonElement>) => {
      if (e) {
        e.stopPropagation();
      }
      if (registerLoading || isPolling || isClicking) return;
      if(getPartnerId() === FACEBOOK){
        FbPixelEvent_Lead();
      }
      setIsClicking(true);
      if (!_isEmpty(userToken)) {
        handleClickCTEventForLoggedInUser();
        handleNavigation();
      } else {
        handleClickCTEventForNonLoggedInUser();
        handleClickCTEventRegisterTournamentNonLoggedInUser();
        localStorage.setItem('gameDetails', JSON.stringify({ gameName, ltid }));
        localStorage.setItem('runGameplay', 'true');
        navigate(NAVIGATION_ROUTES.SIGNIN, {state: {screenName:SCREEN_NAMES.TOURNAMENT_LOBBY}});
      }
      // Reset clicking state after a delay to prevent rapid clicks
      setTimeout(() => setIsClicking(false), 1000);
    }, 300),
    [registerLoading, isPolling, userToken, handleNavigation, navigate, isClicking]
  );

  return (
    <>
      <LoaderOverlay />
      <div 
        className={clsx(styles.mahaMegaCardContainer, {
          [styles.disabled]: isBtnDisabled || registerLoading || isPolling || isClicking
        })} 
        onClick={debouncedJoinTournament}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            debouncedJoinTournament();
          }
        }}
      >
        <GameStatusNotch
          tournament={tournament}
        />
        <div className={clsx(styles.mainBannerBox)}>
          <ImageComponent
            src={displayImage}
            fallbackSrc={mahaMegaBanner}
            alt="maha mega banner"
            className={clsx(styles.mahaMegaBanner)}
          />
        </div>
        <div className={clsx(styles.tournamentEntriesBox)}>
          <label
            className={clsx(
              styles.label,
              "fontWeightRegular fontSizeXs fontColor666 textUppercase"
            )}
          >
            {t("tournamentEntries")}
          </label>
          <ProgressBar value={numRegistrations} max={maxParticipants} />
        </div>
        <div className={clsx(styles.joinBtnBox)}>
          <button 
            className={clsx(styles.joinBtn, "btn primaryBtn")} 
            // onClick={debouncedJoinTournament}
            disabled={isBtnDisabled || registerLoading || isPolling || isClicking}
          >
            {title}
          </button>
          {!isCollapsable && widgetIndex === firstMahaMegaTournamentIndex && (
            <ImageComponent
              src={"https://static-perf1.zupee.com/blog-images/uploads/2025/04/hand-gesture-purple.png"}
              alt="hand gesture"
              className={clsx(styles.handGestureIcon)}
            />
          )}
        </div>
      </div>
    </>
  );
};
export default MahaMegaTournamentCard;
